<div class="client-widget">
    <div class="widget-header">Historical Rates</div>
    <!-- <div class="rate-subheader my-2">
        Powered by Optimal Blue, an independent capital markets intelligence provider
    </div> -->
    <div class="widget-spacing"></div>
    <div class="container avgRatesHistoric" #outerContainer>

        <!-- Zoom Buttons -->
        <div class="d-flex justify-content-center mb-3">
            <button mat-button (click)="setZoom('1w')" class="zoom-button mx-2"
                [ngClass]="{'active': currentZoom === '1w'}">1W</button>
            <button mat-button (click)="setZoom('1m')" class="zoom-button mx-2"
                [ngClass]="{'active': currentZoom === '1m'}">1M</button>
            <button mat-button (click)="setZoom('3m')" class="zoom-button mx-2"
                [ngClass]="{'active': currentZoom === '3m'}">3M</button>
            <button mat-button (click)="setZoom('6m')" class="zoom-button mx-2"
                [ngClass]="{'active': currentZoom === '6m'}">6M</button>
            <button mat-button (click)="setZoom('1y')" class="zoom-button mx-2"
                [ngClass]="{'active': currentZoom === '1y'}">1Y</button>
            <button mat-button (click)="setZoom('all')" class="zoom-button mx-2"
                [ngClass]="{'active': currentZoom === 'all'}">All</button>
        </div>


        <lgv-loading-indicator *ngIf="lgvAvgRatesSvc.isLoadingRates$ | async" [CSSClass]="Small"></lgv-loading-indicator>

        <ng-container *ngIf="chartOptions">

            <!-- The Chart -->

            <div *ngIf="lgvAvgRatesSvc.isLoadingRates$ | async; else chartContent">
                <mat-spinner></mat-spinner>
            </div>

            <ng-template #chartContent>
                <apx-chart #chart [series]="chartOptions.series" [chart]="chartOptions.chart" [xaxis]="chartOptions.xaxis"
                    [dataLabels]="chartOptions.dataLabels" [stroke]="chartOptions.stroke" [markers]="chartOptions.markers"
                    [yaxis]="chartOptions.yaxis" [tooltip]="chartOptions.tooltip" [legend]="chartOptions.legend"
                    [grid]="chartOptions.grid" [fill]="chartOptions.fill" [annotations]="chartOptions.annotations"
                    [colors]="chartOptions.colors"></apx-chart>
            </ng-template>
    
            <div class="custom-legend m-3" #chartContent>
                <div class="h5 mb-3">
                    Loan Programs
                </div>
                <div *ngFor="let series of chartOptions?.series; let i = index" class="legend-item">
                    <!-- Use mat-slide-toggle -->
                    <mat-slide-toggle [unchecked]="seriesVisible[i]" (change)="toggleSeries(i)"
                        [ngStyle]="{ '--toggle-color': seriesColors[i] }">
                        <span>{{ series.name }}</span>
                    </mat-slide-toggle>
                </div>
            </div>
        
        </ng-container>


    </div>
</div>